module.exports = __webpack_public_path__ + "static/media/14UNEP15.9b6f5c37.jpg";